import React, { useEffect } from "react";

import { CalendarView, DesktopHeader } from "@ds-developer/calendar";

import { handleTodayClicked, handleViewSelected } from "../helpers";

import {
  calendarActions,
  selectCalendarInitialDate,
  store,
} from "@hubcapp/state";
import { useSelector } from "react-redux";
import { useTealium } from "@hubcapp/context";

const DesktopCalendarHeaderStateProvider = () => {
  const { trackEvent } = useTealium();
  const initialDate =
    useSelector(selectCalendarInitialDate) || new Date(Date.now());

  const selectCalendarInitialDateHandler = (newDate?: Date) => {
    store.dispatch(
      calendarActions.calendarInitialDateChanged({ initialDate: newDate }),
    );
  };

  useEffect(() => {
    store.dispatch(calendarActions.desktopViewRendered());
  }, []);

  const handleTodayClickedWithTracking = () => {
    handleTodayClicked();
    trackEvent({
      eventCategory: "Calendar",
      eventAction: "Button Click",
      eventLabel: "Today",
    });
  };

  const handleViewSelectedWithTracking = (view: CalendarView) => {
    handleViewSelected(view);
    trackEvent({
      eventCategory: "Calendar",
      eventAction: "Button Click",
      eventLabel: view
        .toLowerCase()
        .replace(/_/g, " ")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
        .trim(),
    });
  };

  return (
    <DesktopHeader
      handleViewSelected={handleViewSelectedWithTracking}
      handleTodayClicked={handleTodayClickedWithTracking}
      initialDate={initialDate}
      selectCalendarInitialDate={selectCalendarInitialDateHandler}
    />
  );
};

export default DesktopCalendarHeaderStateProvider;
